class AccountPasswordController {

  constructor($timeout, authenticateApi, loginoutService) {
    this.$timeout = $timeout;
    this.authenticateApi = authenticateApi;
    this.loginoutService = loginoutService;
  }

  submit () {
    this.saving = true;

    if (!this.validate()) {
      this.$timeout(() => {
        this.saving = false;
      }, 100);
      return;
    }

    return this.authenticateApi.setCustomerPassword({
      customer_id: this.customerId,
      password: this.password
    })
      .then(() => {
        this.success = true;
      })
      .catch(() => {
        this.error = 'Sorry, we were unable to create your account. Please contact us or try again.';
      })
      .then(() => {
        this.saving = false;
      });
  }

  submitCorePassword () {
    this.saving = true;

    if (!this.validate()) {
      this.$timeout(() => {
        this.saving = false;
      }, 100);
      return;
    }

    return this.authenticateApi.setCorePassword({
      core_id: this.coreId,
      password: this.password
    })
      .then(() => {
        this.success = true;
      })
      .catch(() => {
        this.error = 'Sorry, we were unable to set your password. Please contact us or try again.';
      })
      .then(() => {
        this.saving = false;
      });
  }

  validate () {
    this.error = null;
    this.errorSuggestion = null;

    if (!this.password || this.password.length < 8) {
      this.error = 'Please enter a longer password.';
      this.errorSuggestion = 'It must be at least 8 characters in length';
      return false;
    }

    if (this.strength.score <= 2) {
      this.error = 'Please enter a stronger password.';
      this.errorSuggestion = this.strength.feedback.suggestions.join(' ');
      return false;
    }

    return true;
  }

  openLoginPrompt() {
    this.loginoutService.login(true);
  }
}

AccountPasswordController.$inject = [ '$timeout', 'authenticateApi', 'loginoutService' ];

export default AccountPasswordController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/controllers/account.password.controller.js